// Wave RW.3 (2026-05-17) — 매입 실패 사유 모달
// 백엔드: POST /api/rfq/inquiries/:id/fail { failedReason } (5 reason, penalty 분기)

import React, { useState } from 'react';

var FAIL_REASONS = [
  { code: 'owner_refused', label: '차주가 판매 거절',         penalty: 0,  hint: '면책' },
  { code: 'price_changed', label: '차주가 가격 변경 요구',     penalty: 0,  hint: '면책' },
  { code: 'condition',     label: '차량 상태가 사진과 다름',   penalty: 0,  hint: '면책' },
  { code: 'self',          label: '본인 사정',                penalty: -1, hint: '신뢰 차감' },
  { code: 'other',         label: '기타',                    penalty: -1, hint: '신뢰 차감' },
];

function RFQFailModal(props) {
  var onSubmit = props.onSubmit;     // (code) => Promise
  var onClose = props.onClose;
  var [picked, setPicked] = useState(null);
  var [submitting, setSubmitting] = useState(false);
  var [err, setErr] = useState('');

  var doSubmit = function() {
    setErr('');
    if (!picked) { setErr('사유를 선택해주세요'); return; }
    setSubmitting(true);
    onSubmit(picked)
      .catch(function(e){ setErr((e && e.message) || '오류'); })
      .finally(function(){ setSubmitting(false); });
  };

  return (
    <div onClick={onClose} style={backdrop}>
      <div onClick={function(e){ e.stopPropagation(); }} style={modalBox}>
        <h3 style={{ fontSize: 18, fontWeight: 800, color: '#0f172a', marginBottom: 4 }}>매입 실패 보고</h3>
        <div style={{ fontSize: 13, color: '#64748b', marginBottom: 16, lineHeight: 1.5 }}>
          사유에 따라 거래 신뢰 지표 영향이 다릅니다. 정직한 사유 선택이 신뢰도 유지에 유리합니다.
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', gap: 6, marginBottom: 14 }}>
          {FAIL_REASONS.map(function(r) {
            var active = picked === r.code;
            var bad = r.penalty < 0;
            return (
              <button key={r.code} type="button"
                onClick={function(){ setPicked(r.code); }}
                style={{
                  padding: '11px 14px',
                  border: '1.5px solid ' + (active ? '#1B3A5C' : '#e2e8f0'),
                  borderRadius: 8,
                  background: active ? '#f0f4f8' : 'white',
                  textAlign: 'left',
                  cursor: 'pointer',
                  display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                  fontFamily: "'Pretendard',sans-serif",
                }}>
                <span style={{ fontSize: 13, fontWeight: active ? 700 : 600, color: active ? '#1B3A5C' : '#0f172a' }}>
                  {r.label}
                </span>
                <span style={{
                  fontSize: 11, fontWeight: 700,
                  color: bad ? '#dc2626' : '#10b981',
                  padding: '2px 8px', borderRadius: 4,
                  background: bad ? '#fef2f2' : '#ecfdf5',
                }}>
                  {r.hint}
                </span>
              </button>
            );
          })}
        </div>

        {err && (
          <div style={{ background: '#fef2f2', border: '1px solid #fca5a5', color: '#b91c1c', padding: '8px 12px', borderRadius: 8, fontSize: 12, marginBottom: 12 }}>
            {err}
          </div>
        )}

        <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
          <button type="button" onClick={onClose} disabled={submitting} style={btnSecondary}>취소</button>
          <button type="button" onClick={doSubmit} disabled={submitting || !picked} style={btnPrimary(submitting || !picked)}>
            {submitting ? '처리 중...' : '실패 보고'}
          </button>
        </div>
      </div>
    </div>
  );
}

var backdrop = {
  position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
  background: 'rgba(15,23,42,0.5)',
  display: 'flex', alignItems: 'center', justifyContent: 'center',
  zIndex: 1000, padding: 16,
};
var modalBox = {
  background: 'white', borderRadius: 12,
  padding: 24, width: '100%', maxWidth: 440,
  boxShadow: '0 20px 60px rgba(0,0,0,0.2)',
  fontFamily: "'Pretendard',sans-serif",
};
var btnSecondary = {
  padding: '9px 16px',
  background: 'white', border: '1.5px solid #e2e8f0', borderRadius: 8,
  fontSize: 13, fontWeight: 600, color: '#475569',
  cursor: 'pointer',
  fontFamily: "'Pretendard',sans-serif",
};
function btnPrimary(disabled) {
  return {
    padding: '9px 18px',
    background: disabled ? '#cbd5e1' : '#dc2626',
    color: 'white', border: 'none', borderRadius: 8,
    fontSize: 13, fontWeight: 700,
    cursor: disabled ? 'not-allowed' : 'pointer',
    fontFamily: "'Pretendard',sans-serif",
  };
}

export default RFQFailModal;
